import React,{useRef,useEffect,useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

import Paper from '@mui/material/Paper';
import axios from 'axios'
import { styled } from '@mui/material/styles';

const Input = styled('input')({
  display: 'none',
});

const drawerWidth = 300;



const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



function AccountForApprovalInformationDialog(props) {
    const classes = useStyles();

    const [isSavingAccount,setIsSavingAccount] = useState(false)
    const [doSavePotentialAccount,setDoSavePotentialAccount] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [isSavingSuccess,setIsSavingSuccess] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")   
    const selectedAccountForApproval = props.selectedAccountForApproval



    function savePotentialAccount(){
        
        const potentialAccountInformation = new FormData();
        potentialAccountInformation.append('account_code',selectedAccountForApproval.account_code)
        potentialAccountInformation.append('auto_generated_id',selectedAccountForApproval.auto_generated_id)


        setIsSavingAccount(true)
        const options = {
            method: 'POST',
            url: '/TransactiSellerPotentialAccounts/savePotentialAccount.json',
            data: potentialAccountInformation/*objectToFormData(newSellectAccount)*/
          }
           axios(options)
             .then(res => {
      
             
              const isSuccess = res.data.response.is_success
              const message = res.data.response.message

              if(!isSuccess){
              
                setIsSavingSuccess(false)
                setIsSavingAccount(false)
                setMessageDialogMessage(message)
                setShowMessageDialog(true)

    
                return;
              }
           
              setIsSavingSuccess(true)
              setIsSavingAccount(false)
              setMessageDialogMessage(message)
              setShowMessageDialog(true)
              
             }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingAccount(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
               
      
             })

    }
  
    function disapprovedPotentialAccount(){
        
      const potentialAccountInformation = new FormData();
      potentialAccountInformation.append('account_code',selectedAccountForApproval.account_code)
      potentialAccountInformation.append('auto_generated_id',selectedAccountForApproval.auto_generated_id)


      setIsSavingAccount(true)
      const options = {
          method: 'POST',
          url: '/TransactiSellerPotentialAccounts/disapprovePotentialAccount.json',
          data: potentialAccountInformation/*objectToFormData(newSellectAccount)*/
        }
         axios(options)
           .then(res => {
    
           
            const isSuccess = res.data.response.is_success
            const message = res.data.response.message

            if(!isSuccess){
            
              setIsSavingSuccess(false)
              setIsSavingAccount(false)
              setMessageDialogMessage(message)
              setShowMessageDialog(true)

  
              return;
            }
         
            setIsSavingSuccess(true)
            setIsSavingAccount(false)
            setMessageDialogMessage(message)
            setShowMessageDialog(true)
            
           }).catch(error => {

              setIsSavingSuccess(false)
              setIsSavingAccount(false)
              setMessageDialogMessage(error.message)
              setShowMessageDialog(true)
             
    
           })

  }
   
  

    function progressDialog(){
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={isSavingAccount}
          onClose={()=>{}}
        >
         
          <DialogContent>
            <DialogContentText>
              Saving account... Please wait...
            </DialogContentText>
            <LinearProgress color="secondary" />
          </DialogContent>
        </Dialog>
        )
    }
    
    function messageDialog(){
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
                setShowMessageDialog(false)

                if(isSavingSuccess){
                    props.setShowAccountForApprovalDialog(false)
                 
                }
                

                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
    }


     useEffect(()=>{
         if(!doSavePotentialAccount){
            return
         }
        
         setDoSavePotentialAccount(false)
         savePotentialAccount()

     },[doSavePotentialAccount])


    return (
        <div>
           <Dialog fullScreen open={props.showAccountForApprovalDialog} onClose={()=>{

               //props.setAccountActionListener("add")
               

               }} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            
                            props.setShowAccountForApprovalDialog(false)
                            
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                       {"Account for approval"}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            <div style={{padding:'.5rem'}}>

            <Box
                sx={{
                    display: 'flex',
                    alignItems:"center",
                    justifyContent:"center",
                    '& > :not(style)': {
                    m: 1,
                    width: 400,
                    height: 400,
                    },
                }}>
                
                    <label htmlFor="icon-button-file" > 
                        <Paper elevation={3}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height:"100%",
                                padding:"4px"
                            }}
                        >
                       
                        <img
                                width={"100%"}
                                src={selectedAccountForApproval.image}
                                loading="lazy"
                            />
                        </Paper>
                    </label>
            </Box>
            <Grid container spacing={1}>
                <Grid item xs={12} >Account Name:</Grid>
                <Grid item xs={12} style={{marginLeft:"1rem"}}>
                   {selectedAccountForApproval.account_name}
                </Grid>
                <Grid item xs={12} >Account Classification:</Grid>
                <Grid item xs={12} style={{marginLeft:"1rem"}}>
                    {selectedAccountForApproval.classification}
                </Grid>

              
                <Grid item xs={12} >Owner Name:</Grid>
                <Grid item xs={12} style={{marginLeft:"1rem"}}>
                    {selectedAccountForApproval.owner_first_name} {selectedAccountForApproval.owner_middle_name} {selectedAccountForApproval.owner_last_name}
                </Grid>
                <Grid item xs={12} >Contact Number:</Grid>
                <Grid item xs={12} style={{marginLeft:"1rem"}}>
                   {selectedAccountForApproval.contact_number}
                </Grid>

                <Grid item xs={12} >Address :</Grid>
                <Grid item xs={12} style={{marginLeft:"1rem"}}>
                   {selectedAccountForApproval.street.toLowerCase()} {selectedAccountForApproval.barangay.toLowerCase()} {selectedAccountForApproval.city_municipality.toLowerCase()} {selectedAccountForApproval.province.toLowerCase()}
                </Grid>
              
                <Grid container spacing={2}>
                    <Grid item xs={8}>
                        <Button variant="contained" color="primary" style={{width:"100%"}} onClick={()=>{
                            savePotentialAccount()
                        }}>
                        Approve
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="contained" color="error" style={{width:"100%"}} onClick={()=>{
                          disapprovedPotentialAccount()
                        }}>
                        Disapprove
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            </div>
      </Dialog>
      <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            {progressDialog()}
            {messageDialog()}
            </ThemeProvider>
      </StyledEngineProvider>
        </div>
    );
}

export default AccountForApprovalInformationDialog